<div class="w-full create-activity-one cst-content-ctnr">
  <div
    class="w-full p-8 bg-zinc-100 dark:bg-gray-800 flex-col justify-start items-start gap-2.5 inline-flex"
  >
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <!-- Popup succès -->
<div
  *ngIf="successMessage"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40"
  [class.success-popup-fadeout]="isClosing"
>
  <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 success-popup-anim">
    <svg class="success-checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle class="success-checkmark-circle" cx="26" cy="26" r="24" fill="none" />
      <path class="success-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </svg>
    <p class="text-lg font-semibold text-gray-800 text-center">
      {{ successMessage }}
    </p>
  </div>
</div>

<!-- Popup erreur -->
<div
  *ngIf="errorMessage"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40"
>
  <div class="bg-white rounded-2xl shadow-2xl px-10 py-10 flex flex-col items-center gap-4 error-popup-anim">
    <svg class="error-cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
      <circle class="error-cross-circle" cx="26" cy="26" r="24" fill="none" />
      <path class="error-cross-line1" fill="none" d="M17 17l18 18" />
      <path class="error-cross-line2" fill="none" d="M35 17l-18 18" />
    </svg>
    <p class="text-lg font-semibold text-gray-800 text-center">
      {{ errorMessage }}
    </p>
  </div>
</div>
    <div
      class="self-stretch h-full flex-col justify-start items-start gap-[60px] flex"
    >
      <div class="self-stretch rounded-lg bg-white shadow-sm p-6 px-8">
        <div
          class="w-full grow shrink basis-0 flex-col justify-start items-start gap-1 inline-flex"
        >
          <div
            class="w-full titre self-stretch text-gray-900 text-4xl font-semibold leading-[38px]"
          >
            Ajouter un nouveau certificat hors parcours
          </div>

          <div
            class="bg-green-500 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="valid"
          >
            <span class="block sm:inline"> Certificat ajouté avec succès </span>
          </div>

          <div
            class="float-right bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="error"
          >
            <span class="block sm:inline"
              >Erreur lors de l'ajout du certificat
            </span>
          </div>
          <div
            class="bg-red-200 border border-400 text-white-700 px-4 py-3 rounded relative"
            role="alert"
            *ngIf="inValid"
          >
            <span class="block sm:inline"
              >Merci de remplir tous les champs
            </span>
          </div>
          <form class="w-full grow shrink" [formGroup]="hpcertificateForm">
            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="idcertificat"
                  >ID Externe du Certificat</label
                >
                <input
                  [style.border]="inValidId == true ? '1px solid #EB4045' : ''"
                  formControlName="idcertificat"
                  id="idcertificat"
                  type="text"
                  placeholder="ID du certificat dans la plateforme LMS"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <p class="italic text-blue-500 f14 text-xs mt-1">
                  Chiffres seulement
                </p>
              </div>
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="name"
                  >Nom Certificat
                </label>
                <input
                  [style.border]="
                    inValidName == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="name"
                  id="name"
                  type="text"
                  placeholder="Nom Certificat"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="fullname"
                  >Nom Complet</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="fullname"
                  id="fullname"
                  placeholder="Nom Complet du certificat"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>

              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="fullname"
                  >Nom abrégé</label
                >
                <input
                  [style.border]="
                    invalidFullname == true ? '1px solid #EB4045' : ''
                  "
                  type="text"
                  formControlName="shortname"
                  id="shortname"
                  placeholder="Nom abrégé"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="displayname"
                  >Nom à Afficher</label
                >
                <input
                  [style.border]="
                    invalidDisplayname == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="displayname"
                  id="displayname"
                  type="text"
                  placeholder="Nom à Afficher"
                  class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="displayname"
                  >Catégorie</label
                >

                <select
                  [style.border]="
                    invalidCategorie == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="category"
                  id="category"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>
                    <p class="text-gray-50">Choisissez la Catégorie</p>
                  </option>
                  <option
                    *ngFor="let category of categorys"
                    [value]="category.id"
                  >
                    {{ category.categoryName }}
                  </option>
                </select>
              </div>

              <!-- ***************** ADD BY ME POUR QUE LE USER PUISSE SAISIR SUR LE CHAMPS certificatcode************ -->

              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
              <label
                class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                for="certificatCode"
                >Code du certificat</label
              >

              <!-- Mode création : select -->
              <select
                *ngIf="!isDuplicating"
                formControlName="certificatCode"
                id="certificatCode"
                class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
              >
                <option value="">Aucun</option>
                <option *ngFor="let c of certificatCodes" [value]="c.code">
                  {{ c.label }}
                </option>
              </select>

              <!-- Mode duplication : saisie libre -->
              <input
                *ngIf="isDuplicating"
                formControlName="certificatCode"
                id="certificatCode"
                type="text"
                placeholder="Code du certificat"
                class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
              />
            </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="plateforme"
                  >Plateforme</label
                >
                <select
                  [style.border]="
                    invalidPlatforme == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="plateforme"
                  id="plateforme"
                  class="w-full pr-db px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 gap-2"
                >
                  <option value="" disabled>
                    <p class="text-gray-50">Choisissez la plateforme LMS</p>
                  </option>
                  <option *ngFor="let platform of platforms" [value]="platform">
                    {{ platform }}
                  </option>
                </select>
              </div>
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="urlCertificat"
                  >URL Certificat</label
                >
                <input
                  [style.border]="invalidUrl == true ? '1px solid #EB4045' : ''"
                  formControlName="urlCertificat"
                  id="urlCertificat"
                  type="url"
                  placeholder="Lien vers le certificat"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="startdate"
                  >Date de début
                </label>
                <input
                  [style.border]="
                    inValidStartdate == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="startdate"
                  id="startdate"
                  type="date"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="enddate"
                  >Date de fin</label
                >
                <input
                  [style.border]="
                    inValidEnddate == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="enddate"
                  id="enddate"
                  type="date"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>
            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full pr-db pt-2 justify-start items-center gap-5">
                <label
                  class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full"
                  for="enddate"
                  >Date de l'appel hors-parcous</label
                >
                <input
                  [style.border]="
                    inValidAppeldate == true ? '1px solid #EB4045' : ''
                  "
                  formControlName="appeldate"
                  id="appeldate"
                  type="date"
                  class="w-full pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <p class="italic text-blue-500 f14 text-xs mt-1">
                  Mettez la date correspondant à la date d'ouverture de la
                  campagne hors Parcours.
                </p>
              </div>
            </div>

            <div class="py-3 rounded-xl gap-4">
              <label
                class="mb-1 pr-db font-medium inter-medium f14 color-gray-700 w-full pt-4"
                for="description"
                >Description du certificat</label
              >
              <textarea
                [style.border]="
                  invalidDescription == true ? '1px solid #EB4045' : ''
                "
                formControlName="description"
                id="description"
                placeholder="Description du  certificat"
                class="w-full no-resize mb-1 pr-db mat-mdc-input-element self-stretch px-3.5 py-2.5 bg-white rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                maxlength="300"
              ></textarea>
              <div
                class="indications mb-1 pr-db font-medium inter-medium f12 color-gray-300 w-full text-xs"
              >
                300 caractères autorisés
              </div>
            </div>

            <div
              class="py-3 rounded-xl gap-4 flex justify-content-between flex-column sm:flex-row"
            >
              <div class="w-full flex pt-2 justify-end items-end gap-2">
                <input
                  type="reset"
                  style="border-radius: 0.5rem"
                  value="Annuler"
                  (click)="resetCreation()"
                  class="text-sm w-fit text-white mat-mdc-input-element font-semibold self-stretch px-2.5 py-2.5 bg-red rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
                <input
                  type="submit"
                  value="Sauvegarder"
                  style="border-radius: 0.5rem"
                  (click)="openConfirmModal()"
                  [disabled]="valid"
                  class="text-sm w-fit text-white mat-mdc-input-element bg-blue font-semibold self-stretch px-2.5 py-2.5 rounded-lg shadow border border-gray-300 justify-start items-center gap-2 inline-flex"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal de confirmation -->
  <div
    *ngIf="showConfirmModal"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="bg-white rounded-xl shadow-xl w-full max-w-md p-8 flex flex-col gap-6"
    >
      <!-- Icône + Titre -->
      <div class="flex flex-col items-center gap-3 text-center">
        <div class="bg-blue-100 rounded-full p-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-10 w-10 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h2 class="text-2xl font-semibold text-gray-900">
          Confirmer la création
        </h2>
        <p class="text-slate-600 text-base">
          Vous êtes sur le point d'ajouter un certificat hors parcours.<br />
          Voulez-vous confirmer cette action ?
        </p>
      </div>

      <!-- Récapitulatif -->
      <div
        class="bg-zinc-50 rounded-lg border border-gray-200 px-5 py-4 text-sm text-gray-700 flex flex-col gap-2"
      >
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Nom :</span>
          <span class="font-semibold">{{
            hpcertificateForm.get("name")?.value
          }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Nom abrégé :</span>
          <span>{{ hpcertificateForm.get("shortname")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Plateforme :</span>
          <span>{{ hpcertificateForm.get("plateforme")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Date de début :</span>
          <span>{{ hpcertificateForm.get("startdate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Date de fin :</span>
          <span>{{ hpcertificateForm.get("enddate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Date de l'appel :</span>
          <span>{{ hpcertificateForm.get("appeldate")?.value }}</span>
        </div>
        <div class="flex justify-between">
          <span class="font-medium text-gray-500">Cohorte générée :</span>
          <span class="italic text-blue-500">{{
            createCohorte(hpcertificateForm.get("appeldate")?.value)
          }}</span>
        </div>
      </div>

      <!-- Boutons -->
      <div class="flex justify-end gap-3">
        <button
          (click)="cancelSubmit()"
          class="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition focus:outline-none"
        >
          Annuler
        </button>
        <button
          (click)="confirmSubmit()"
          class="px-5 py-2 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold transition focus:outline-none"
        >
          Confirmer
        </button>
      </div>
    </div>
  </div>
</div>
